import { render } from "./AddEvaluationForm.vue?vue&type=template&id=b6dfe2ee"
import script from "./AddEvaluationForm.vue?vue&type=script&lang=js"
export * from "./AddEvaluationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/AddEvaluationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6dfe2ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6dfe2ee', __exports__)) {
    api.reload('b6dfe2ee', __exports__)
  }
  
  module.hot.accept("./AddEvaluationForm.vue?vue&type=template&id=b6dfe2ee", () => {
    api.rerender('b6dfe2ee', render)
  })

}


export default __exports__